<template>
	<div class="main-panel">
		<table height=100% width=100% cellpadding=0 cellspacing=0>
            <tr height="100%">
                <div class="inner-panel">
                    <el-tabs v-if="showTab" v-model="selectedTabName" type="card">
                        <el-tab-pane :label="$t('message.item_tenant')" name="settingInfo"></el-tab-pane>
                        <div v-if="selectedTabName=='settingInfo'" class="object-inner-table" style="margin-top: 10%;">
                            <div v-if="twoPhaseMethodConsole" class="default-message">
                                <span v-html="$t('message.info_two_phase_method_console_guide4')"></span><br><br>
                                <span v-html="$t('message.info_two_phase_method_console_guide5')"></span><br><br>
                                <span v-html="$t('message.info_two_phase_method_console_guide6')"></span><br><br>
                                <div class="information-message">
                                    <a
                                        href="https://www.science-arts.com/downloads/buddycom/manual//buddycom/Buddycom_Console_Guide_setting.pdf"
                                        v-t="'message.info_how_to_set'"
                                        target="_blank" 
                                        rel="noopener noreferrer">
                                    </a>
                                </div>
                            </div>
                            <div v-else class="default-message">
                                <span v-html="$t('message.info_two_phase_method_console_notice')"></span><br><br>
                                <span v-html="$t('message.info_two_phase_method_console_guide3')"></span><br><br>
                                <div class="information-message">
                                    <a
                                        href="https://www.science-arts.com/downloads/buddycom/manual//buddycom/Buddycom_Console_Guide_setting.pdf"
                                        v-t="'message.info_how_to_set'"
                                        target="_blank" 
                                        rel="noopener noreferrer">
                                    </a>
                                </div>
                            </div>
                            <div class="object-titlebox">
                                <div class="object-titlebox-right">
                                    <button class="transparent-button" type="button" v-on:click="showEdit">
                                        <img src="../../../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span>
                                    </button>
                                </div>
                            </div>
                            <table width="100%">
                                <!-- twoPhaseMethod:1.メール認証 :2.GA認証  -->
                                <tr class="objectitem-record">
                                    <td width=40% class="object-item" v-t="'message.item_two_phase_method'"></td>
                                    <td width=50% class="object-value"> {{ displayTwoPhaseMethod }} </td>
                                </tr>
                                <tr class="objectitem-record" v-if="methodOption === LOGIN_METHOD_MAIL">
                                    <td width=40% class="object-item" v-t="'message.item_two_phase_method_target'"></td><td class="object-value">{{ displayEmail }}</td>
                                </tr>
                            </table>
                        </div>
                    </el-tabs>
                </div>
            </tr>
        </table>
        <twoPhaseLoginInfoEdit 
            v-if="showTwoPhaseLoginInfoEdit" 
            ref="TwoPhaseLoginInfoEdit"
            :methodOption="methodOption"
            :email="email"
            @next="goTwoPhaseSetting"
            @save="verifyTwoPhaseAuthInfo"
            @cancel="showTwoPhaseLoginInfoEdit=false" 
        />
        <twoPhaseMailVerify
            v-if="showTwoPhaseMailVerify"
            ref="TwoPhaseMailVerify"
            :email="inputEmail"
            :errorInfo="errorInfo"
            @verified="verifyTwoPhaseAuthInfo"
            @cancel="showTwoPhaseMailVerify=false"
        />
        <twoPhaseGASetting
            v-if="showTwoPhaseGASetting"
            ref="TwoPhaseGASetting"
            :errorInfo="errorInfo"
            @verified="verifyTwoPhaseAuthInfo"
            @cancel="showTwoPhaseGASetting=false"
        />
	</div>
</template>

<script>
import Vue from 'vue'
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import TwoPhaseLoginInfoEdit from '@/components/pc/setting/twophasemethod/TwoPhaseLoginInfoEdit.vue';
import TwoPhaseGASetting from '@/components/pc/setting/twophasemethod/TwoPhaseGASetting.vue';
import TwoPhaseMailVerify from '@/components/pc/setting/twophasemethod/TwoPhaseMailVerify.vue';

export default {
    components: {
        twoPhaseLoginInfoEdit: TwoPhaseLoginInfoEdit,
        twoPhaseGASetting: TwoPhaseGASetting,
        twoPhaseMailVerify: TwoPhaseMailVerify
    },
    props: ['appData'],
    data () {
        return {
            // CONST
            LOGIN_METHOD_MAIL: constants.LOGIN_METHOD_MAIL,
            LOGIN_METHOD_GA: constants.LOGIN_METHOD_GA,

            showTwoPhaseLoginInfoEdit: false,
            showTwoPhaseGASetting: false,
            showTwoPhaseMailVerify: false,
            methodOption: constants.LOGIN_METHOD_NO_SETTING,
            email: "",
            inputEmail: "",
            selectedTabName: "",
            showTab: true,
            twoPhaseMethodConsole: false,
            errorInfo: null,
        };
    },
    methods: {
        getMethodName(value) {
            let messageKey;
            switch (value) {
                case constants.LOGIN_METHOD_MAIL:
                    messageKey = "item_value_two_pahse_auth_mail";
                    break;
                case constants.LOGIN_METHOD_GA:
                    messageKey = "item_value_two_pahse_auth_ga";
                    break;
                default:
                    messageKey = "item_value_notSet";
                    break;
            }
            return commonUtil.getMessageText(this.$i18n, messageKey);
        },
        goTwoPhaseSetting(input) {
            if (input.methodOption === constants.LOGIN_METHOD_MAIL) {
                this.inputEmail = input.email.value;
                this.showTwoPhaseMailVerify = true;
            }
            if (input.methodOption === constants.LOGIN_METHOD_GA) {
                this.showTwoPhaseGASetting = true;
            }
            this.showTwoPhaseLoginInfoEdit = false;
        },
        displayTwoPhaseAuthInfo(twoPhaseAuthInfo) {
            this.methodOption = twoPhaseAuthInfo.methodOption;
            this.email = twoPhaseAuthInfo.methodOption === constants.LOGIN_METHOD_MAIL ? twoPhaseAuthInfo.email : null;
            this.showTwoPhaseMailVerify = false;
            this.showTwoPhaseGASetting = false;
            this.showTwoPhaseLoginInfoEdit = false;
        },
        verifyTwoPhaseAuthInfo(request) {
            const self = this;
            server.post('/modifyconsoletwophasemethod', request)
            .then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_two_phase_method_edited"));
                        self.methodOption = request.methodOption;
                        self.email = request.methodOption === constants.LOGIN_METHOD_MAIL ? request.email : null;
                        self.errorInfo = null
                        self.displayTwoPhaseAuthInfo(request)
                        break;
                    case constants.STATUS_ERROR_INVALID_TWO_PHASE_METHOD:
                        self.errorInfo = commonUtil.getMessageText(self.$i18n,"error_invalid_confirmCode_ga");
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_two_phase_method_edit"));
                        self.showTwoPhaseMailVerify = false;
                        self.showTwoPhaseGASetting = false;
                        self.showTwoPhaseLoginInfoEdit = false;
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","verifyTwoPhaseAuthInfo").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch((error) => {
                commonUtil.putExceptionErrorMessage(self, "verifyTwoPhaseAuthInfo", error);
            });
        },
        getTwoPhaseAuthInfo() {
            server.post('/getconsoletwophaseauthinfo')
            .then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.methodOption = res.data.methodOption
                        this.email = res.data.methodOption === constants.LOGIN_METHOD_MAIL ? res.data.email : null;
                        return;
                    case constants.STATUS_ERROR_DENIED:
                        return;
                    default:
                        commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","getTwoPhaseAuthInfo").replace("{code}",res.data.status));
                        return;
                }
            })
            .catch((error) => {
                commonUtil.putExceptionErrorMessage(this, "getTwoPhaseAuthInfo", error);
            });
        },
        showEdit() {
            if (this.twoPhaseMethodConsole) {
                this.showTwoPhaseLoginInfoEdit = true;
            } else {
                this.showTwoPhaseLoginInfoEdit = false;
                commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_two_phase_method_edit"));
            }
        }
    },
    mounted() {
        this.selectedTabName = "settingInfo";
        this.twoPhaseMethodConsole = this.appData.twoPhaseMethodConsole;
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.getTwoPhaseAuthInfo();
        });
    },
    watch: {
        'appData.twoPhaseMethodConsole'(newVal) {
            this.twoPhaseMethodConsole = newVal;
        }
    },
    computed: {
        displayTwoPhaseMethod () {
            let messageKey;
            switch (this.methodOption) {
                case constants.LOGIN_METHOD_MAIL:
                    messageKey = "item_value_two_pahse_auth_mail";
                    break;
                case constants.LOGIN_METHOD_GA:
                    messageKey = "item_value_two_pahse_auth_ga";
                    break;
                default:
                    messageKey = "item_value_notSet";
                    break;
            }
            return commonUtil.getMessageText(this.$i18n, messageKey);
        },
        displayEmail () {
            return this.email;
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.method {
    height: 90px;
    padding-top: 10px;
    font-size: 14px;
    vertical-align: top;
}

.code-guide-text {
     font-size: 16px;
     font-weight: 600;
     color: #5171cb;
 }

 .two-phase-auth-info {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    color: #848991;
}

.record {
    border-bottom:1px #eee solid;
}

.information-header {
    padding: 10px 0 10px 20px;
    color: #848991;
    background-color:#f6f6f6;
    font-size: 12px;
}

.information-header-left {
  color: #848991;
  font-size: 12px;
  vertical-align: middle;
  float: left;
}

.information-header-right {
  padding-right: 10px;
  position: relative;
  text-align : right;
  vertical-align: middle;
  font-size: 12px;
}

.information-message {
    padding-bottom: 20px;
    font-size: 14px;
    text-align: center;
}

</style>
